export const customerKeys = {
    all: ['customers'] as const,
    detail: (id: string) => [...customerKeys.all, id] as const,
    amendments: (id: string) => [...customerKeys.detail(id), 'amendments'] as const,
    amendmentsPage: (id: string, page: number, perPage: number) =>
        [...customerKeys.amendments(id), 'page', page, perPage] as const,
};
